import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReactQuill from "react-quill";
import { MdMail, MdCircle, MdAddCircleOutline, MdCalendarMonth, MdArrowBack, MdArrowLeft, MdArrowRight, MdAttachFile, MdClose, MdFileCopy, MdFilePresent, MdForward, MdForward10, MdForwardToInbox, MdReply, MdSend } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import dayjs from 'dayjs';
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { web_url } from "../../constant";
import { useWebSocket } from "../../websocket_context";

function TranslatorMessageDashboardWithReadDesktop() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const navigate = useNavigate();
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });

    const [content, setContent] = useState({
        messageId: "",
        threadId: "",
        subject: "",
        other: ''
    });


    const [messagesArray, setmessagesArray] = useState([
        {
            messageId: "",
            sender: "",
            body: "",
            status: "",
            sentAt: "",
            sentAtOriginal: "",
            language: "",
            type: "",
            attachments: [],
            otherPerson: "",
            receiver: ''
        }
    ])
    const [indexOfMessageShowingNow, setIndexOfMessageShowingNow] = useState(0)

    const [isReceived, setIsReceived] = useState(false);

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    useEffect(() => {
        if (localStorage.getItem('mailsent')) {
            const mail = JSON.parse(localStorage.getItem('mailsent'));
            setIndexOfMessageShowingNow(0);
            setContent(mail)
        } else if (localStorage.getItem('maildraft')) {
            const mail = JSON.parse(localStorage.getItem('maildraft'));
            setIndexOfMessageShowingNow(0);
            setContent(mail)
        } else if (localStorage.getItem('mailreceived')) {
            const mail = JSON.parse(localStorage.getItem('mailreceived'));
            setIndexOfMessageShowingNow(0);
            setContent(mail)
        } else {

            alert("no mail")
        }
    }, [localStorage.getItem('mailsent'), localStorage.getItem('mailreceived'), localStorage.getItem('maildraft')])

    useEffect(() => {
        if (messagesArray) {
            if (messagesArray[indexOfMessageShowingNow]?.receiver === logDetails.email) {
                // console.log("abi idiot 1");
                setIsReceived(true)
            } else {
                // console.log("abi idiot 2");
                setIsReceived(false)
            }
        }
    }, [indexOfMessageShowingNow, messagesArray])

    useEffect(() => {

        // console.log('received',isReceived);

    }, [isReceived])

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };


    useEffect(() => {
        setIsLoading(true);
        if (content.threadId) {

            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            axios.get(`${web_url}/api/email-threads/${content.threadId}`, configToken).then((response) => {
                // console.log("resnow", response.data);

                const sortedMessages = response.data.messages
                    .sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt))
                    .map((message) => ({
                        ...message,
                        receiver: response.data.participants.find(email => email !== message.sender)
                    }));
                setmessagesArray(sortedMessages);
                setIsLoading(false);


            }).catch((err) => {
                handleClickOpenError('error occured')
                setIsLoading(false);
            })
        }
    }, [content])
    // console.log("this is tha response", messagesArray);
    useEffect(() => {

    }, [messagesArray])

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    // const formats = ["bold", "italic", "underline", "list", "bullet", "size"];

    const [showLeftArrow, setShowLeftArrow] = useState(false)
    const [showRightArrow, setShowRightArrow] = useState(false)

    useEffect(() => {
        if (messagesArray) {
            if (messagesArray.length === 1) {
                setShowLeftArrow(false);
                setShowRightArrow(false);
                setIndexOfMessageShowingNow(0);
            } else {
                const index = messagesArray.findIndex((message) => message.messageId === content.messageId);
                setIndexOfMessageShowingNow(index);
            }
        }
    }, [messagesArray])

    useEffect(() => {
        if (messagesArray.length === 1) {
            setShowLeftArrow(false);
            setShowRightArrow(false);
            setIndexOfMessageShowingNow(0);
        } else {
            if (indexOfMessageShowingNow === (messagesArray.length) - 1) {
                setShowRightArrow(false);
            } else {
                setShowRightArrow(true);
            }

            if (indexOfMessageShowingNow === 0) {
                setShowLeftArrow(false);
            } else {
                setShowLeftArrow(true);
            }
        }

        // console.log('message', messagesArray[indexOfMessageShowingNow]);

    }, [indexOfMessageShowingNow, messagesArray])

    const handleRightArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow + 1);
    }

    const handleLeftArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow - 1);
    }

    const handleReplyButton = () => {
        const mailRequest = {
            type: 'old',
            threadId: content.threadId,
            subject: content.subject,
            to: isReceived ? content.sender : content.other,
        };
        localStorage.setItem('threadId', JSON.stringify(mailRequest));
        if (isXlOrLarger) {
            navigate('/desktop/translator/mailbox');
        } else {
            navigate('/mobile/translator/mailbox/composemail');
        }
    }

    const [isLoading2, setIsLoading2] = useState(false)

    const [searchInput, setSearchInput] = useState("");

    const [mailsInbox, setMailsInbox] = useState([]);

    const [mailsSent, setMailsSent] = useState([]);

    const [mailsDraft, setMailsDraft] = useState([]);
    const [date, setDate] = useState(null)

    const [showCloseIcon, setShowCloseIcon] = useState(null)

    const messageIdsSet = useRef(new Set());
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [numberOfUnread, setNumberOfUnread] = useState(0);

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading2(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            axios.get(`${web_url}/api/email-threads/participants/${logDetails.email}`, configToken).then((response) => {

                let allMessages = response.data.flatMap(thread =>
                    thread.messages.map(message => ({
                        ...message,
                        threadId: thread.threadId,
                        subject: thread.subject || " ",
                        sentAt: formatDate(message.sentAt),
                        sentAtOriginal: formatDateNew(message.sentAt),
                        other: thread.participants.find(email => email !== message.sender) || null,
                        isRead: thread.participantsStatus
                            ? thread.participantsStatus.find(person => person.email === logDetails.email)?.isRead ?? true
                            : true
                    }))
                );

                allMessages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));

                const sentMessages = allMessages.filter(msg => msg.sender === (logDetails.email) && msg.isDraft === "FALSE");
                // const receivedMessages = allMessages.filter(msg => msg.sender !== (logDetails.email) && msg.isDraft === "FALSE");

                const receivedMessages2 = allMessages
                    .filter(msg => msg.sender !== logDetails.email && msg.isDraft === "FALSE" && msg.status === "APPROVED")
                    .reduce((acc, msg) => {
                        if (!acc[msg.threadId] || new Date(msg.sentAt) > new Date(acc[msg.threadId].sentAt)) {
                            acc[msg.threadId] = msg;
                        }
                        return acc;
                    }, {});

                // console.log("rec", receivedMessages2);

                const receivedMessages = Object.values(receivedMessages2);

                const draftMessages = allMessages.filter(msg => msg.sender === (logDetails.email) && msg.isDraft === "TRUE");

                setMailsDraft(draftMessages);
                setMailsInbox(receivedMessages);
                setMailsSent(sentMessages);
                setNumberOfUnread(receivedMessages.filter(msg => !msg.isRead).length);
                receivedMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                sentMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                draftMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));

                setIsLoading2(false);
                setIsDataLoaded(true);
            }).catch((err) => {
                setIsLoading2(false);
                handleClickOpenError("error occured");
            })
        }
    }, [localStorage.getItem('refresh')])

    const { subscribeToTopic } = useWebSocket();


    useEffect(() => {
        if (!isDataLoaded) return;
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        subscribeToTopic((data) => {
            if (!data.participants.includes(logDetails.email)) return;
            const responseBody = data;
            let messages = responseBody.messages.map(message => ({
                ...message,
                threadId: responseBody.threadId,
                subject: responseBody.subject || " ",
                sentAt: formatDate(message.sentAt),
                sentAtOriginal: formatDateNew(message.sentAt),
                other: responseBody.participants.find(email => email !== message.sender) || null,
                isRead: responseBody.participantsStatus?.find(person => person.email === logDetails.email)?.isRead ?? true
            }));

            messages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));

            const sentMessages = messages.filter(msg => msg.sender === logDetails.email && msg.isDraft === "FALSE");
            const receivedMessages = Object.values(
                messages
                    .filter(msg => msg.sender !== logDetails.email && msg.isDraft === "FALSE" && msg.status === "APPROVED")
                    .reduce((acc, msg) => {
                        if (!acc[msg.threadId] || new Date(msg.sentAt) > new Date(acc[msg.threadId].sentAt)) {
                            acc[msg.threadId] = msg;
                        }
                        return acc;
                    }, {})
            );

            const draftMessages = messages.filter(msg => msg.sender === logDetails.email && msg.isDraft === "TRUE");

            // Remove duplicates before updating state
            const uniqueReceivedMessages = receivedMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            const uniqueSentMessages = sentMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            const uniqueDraftMessages = draftMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });
            setNumberOfUnread(prev => prev + uniqueReceivedMessages.filter(msg => !msg.isRead).length);
            setMailsDraft(prev => [...prev, ...uniqueDraftMessages]);
            setMailsInbox(prev => [...prev, ...uniqueReceivedMessages]);
            setMailsSent(prev => [...prev, ...uniqueSentMessages]);
        });

    }, [isDataLoaded]);


    useEffect(() => {
        if (date !== null) {
            setShowCloseIcon(true)
        } else {
            setShowCloseIcon(false)
        }
    }, [date])

    const filteredEmailsInbox = (mailsInbox ?? []).filter((mail) =>
        (mail.body?.toLowerCase() || '') + (mail.subject?.toLowerCase() || '')
            .includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );

    const filteredEmailsSent = (mailsSent ?? []).filter((mail) =>
        (mail.body?.toLowerCase() || '') + (mail.subject?.toLowerCase() || '')
            .includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );

    const filteredEmailsDraft = (mailsDraft ?? []).filter((mail) =>
        (mail.body?.toLowerCase() || '') + (mail.subject?.toLowerCase() || '')
            .includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );

    // const filteredEmailRejected = (mailsRejected ?? []).filter((mail) =>
    //     mail.other?.toLowerCase().includes(searchInput.toLowerCase()) &&
    //     (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    // );


    const [folderSelected, setFolderSelected] = useState(
        () => {
            const selected = localStorage.getItem('folder') ? parseInt(localStorage.getItem('folder'), 10) : 4;
            // console.log('fold', selected);

            if (selected === 0) {
                return {
                    sent: false,
                    inbox: true,
                    draft: false,
                    compose_new: false
                }
            } else if (selected === 1) {
                return {
                    sent: true,
                    inbox: false,
                    draft: false,
                    compose_new: false
                }
            } else if (selected === 2) {
                return {
                    sent: false,
                    inbox: false,
                    draft: true,
                    compose_new: false
                }
            } else {
                return {
                    sent: false,
                    inbox: false,
                    draft: false,
                    compose_new: true
                }
            }
        }
    )

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0;
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }

    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    const [nowReading, setNowReading] = useState(() => {
        const number = localStorage.getItem('nowreading') ? parseInt(localStorage.getItem('nowreading'), 10) : 100000;
        return number;
    });

    useEffect(() => {
        localStorage.setItem('nowreading', 100000);

    }, [folderSelected])

    const handleInboxMailReadClick = (mail, index) => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.patch(`${web_url}/api/email-threads/${mail.threadId}/${logDetails.email}/read?threadReadStatus=true`, {}, configToken).then((r) => {
            localStorage.setItem('nowreading', index);
            localStorage.setItem("refresh", `${Date.now()}`);
            setIsLoading(false);
            localStorage.setItem('mailreceived', JSON.stringify(mail));
            localStorage.removeItem('maildraft');
            localStorage.removeItem('mailsent');
            localStorage.setItem('composenewclicked', 'false');
            navigate('/desktop/translator/mailbox/read');
            // navigate('/StudentEmailViewPageMobile');
        }).catch((e) => {
            setIsLoading(false);
            handleClickOpenError('error occured')
        })

    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/translator/mailbox/read')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleDownload = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "translator") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const [lang, setLang] = useState(i18n.language);

    useEffect(() => {
        if (i18n.language !== lang) {
            setLang(i18n.language);
            changeLanguage(i18n.language);
        }
    }, [i18n.language]);

    const [openDesktopCalendar, setOpenDesktopCalendar] = useState(false);


    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-full xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-b.svg" alt="home" onClick={() => navigate('/desktop/translator/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-w.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/translator/mailbox')

                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img title="Settings" src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/translator/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className="hidden xl:grid grid-cols-3 w-full">
                <div className="col-span-2">
                    {/* <div className="mb-[100px] lg:mb-[130px] xl:mb-[20px]">
                        <div className="pl-[30px] pr-[30px] xl:pr-[5px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[20px] 2xl:pt-[25px]">

                            {
                                isLoading2 ?
                                    <div className="items-center justify-center flex pt-[30px]">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                    </div>
                                    :
                                    <div className="md:mx-[30px] lg:mx-[100px] xl:mx-[60px]">
                                        <div>
                                            <input
                                                type="search"
                                                placeholder={t('t228')}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                value={searchInput}
                                                className="mt-4 p-2 md:p-3 lg:p-4 xl:p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px]"
                                            />
                                        </div>
                                        <div className="flex justify-evenly md:justify-center xl:justify-start">
                                            <div className="w-[150px] h-[40px] md:w-[200px] md:h-[50px] xl:h-[40px] flex justify-center items-center text-[90px] md:text-[22px] xl:text-[16px] md:mr-[10px] min-w-[100px] rounded-md px-[2px] py-[0px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px]  border border-1 mt-[10px] border-gray-400 text-gray-700 bg-[#F1F6FB]">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        value={date ? dayjs(date) : null}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                                setDate(formattedDate)
                                                            }
                                                        }}
                                                        format="YYYY-MM-DD"
                                                        slotProps={{
                                                            textField: {
                                                                InputProps: {

                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: window.innerWidth < 640 ? '14px' : window.innerWidth < 1024 ? '17px' : '17px',
                                                                        color: '#1F2937',
                                                                        fontFamily: 'Urbanist',
                                                                        padding: '0 0 0 0'
                                                                    },
                                                                },
                                                                placeholder: t('t229'),
                                                                fullWidth: true,
                                                                sx: {
                                                                    '& .MuiOutlinedInput-root': {
                                                                        border: 'none', // Remove outer border
                                                                        boxShadow: 'none', // Remove shadow
                                                                    },
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none', // Remove outlined border
                                                                    },
                                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none', // Remove hover effect
                                                                    },
                                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none', // Remove focus effect
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                {
                                                    !showCloseIcon && <MdCalendarMonth size="30px" className="xl:hidden text-gray-500 ml-[5px]" />
                                                }
                                                {
                                                    showCloseIcon && <MdClose onClick={() => setDate(null)} size="30px" className="2xl:block text-gray-500 ml-[5px]" />
                                                }
                                            </div>
                                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.inbox ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => {
                                                setNowReading(100000);
                                                localStorage.setItem("folder", 0);
                                                setFolderSelected({ sent: false, inbox: true, draft: false, compose_new: false })
                                            }} >{t('t230')}</button>
                                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.sent ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => {
                                                setNowReading(100000);
                                                localStorage.setItem("folder", 1);
                                                setFolderSelected({ sent: true, inbox: false, draft: false, compose_new: false })
                                            }}>{t('t231')}</button>
                                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.draft ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => {
                                                setNowReading(100000);
                                                localStorage.setItem("folder", 2);
                                                setFolderSelected({ sent: false, inbox: false, draft: true, compose_new: false })
                                            }}>{t('t232')}</button>
                                            <button className={`hidden xl:block ml-[10px] text-[15px] md:text-[20px] xl:text-[16px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.compose_new ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`}
                                                onClick={() => {
                                                    localStorage.setItem("folder", 4);
                                                    const mailRequest = {
                                                        type: 'new',
                                                        subject: 'nothing'
                                                    };
                                                    localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                                    setFolderSelected({ sent: false, inbox: false, draft: false, compose_new: true })
                                                    localStorage.setItem('composenewclicked', 'true');
                                                    navigate('/desktop/translator/mailbox')
                                                }}>{t('t233')}</button>
                                        </div>

                                        <div className="hidden xl:block">
                                            {
                                                folderSelected.inbox &&
                                                <div className="mt-6">
                                                    {filteredEmailsInbox
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${mail.isRead === false ? 'bg-[#d0deec]' : (nowReading === index ? 'bg-[#D9D9D9]' : 'bg-[#F1F6FB]')} mb-[10px] md:mb-[15px] p-[10px] rounded-md`}
                                                                onClick={() => {
                                                                    setNowReading(index)
                                                                    handleInboxMailReadClick(mail, index)
                                                                }}
                                                            >
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 30
                                                                            ? `${mail.subject.slice(0, 30)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 60
                                                                            ? `${mail.subject.slice(0, 60)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 70
                                                                            ? `${mail.subject.slice(0, 70)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 100
                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 140
                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                            {
                                                folderSelected.sent &&
                                                <div className="mt-6">
                                                    {filteredEmailsSent
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${(nowReading === index ? 'bg-[#D9D9D9]' : 'bg-[#F1F6FB]')} mb-[10px] md:mb-[15px] p-[10px] rounded-md`}
                                                                onClick={() => {
                                                                    setNowReading(index)
                                                                    localStorage.setItem('mailsent', JSON.stringify(mail));
                                                                    localStorage.removeItem('maildraft');
                                                                    localStorage.removeItem('mailreceived');
                                                                    localStorage.setItem('composenewclicked', 'false');
                                                                    navigate('/desktop/translator/mailbox/read');
                                                                }}>
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.other}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 30
                                                                            ? `${mail.subject.slice(0, 30)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 60
                                                                            ? `${mail.subject.slice(0, 60)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 70
                                                                            ? `${mail.subject.slice(0, 70)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 100
                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 140
                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                            {
                                                folderSelected.draft &&
                                                <div className="mt-6">
                                                    {filteredEmailsDraft
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${(nowReading === index ? 'bg-[#D9D9D9]' : 'bg-[#F1F6FB]')} mb-[10px] md:mb-[15px] p-[10px] rounded-md`}
                                                                onClick={() => {
                                                                    localStorage.setItem('nowreading', index);
                                                                    const mailRequest = {
                                                                        type: 'draft',
                                                                        threadId: mail.threadId,
                                                                        subject: mail.subject,
                                                                        to: mail.other,
                                                                        attachments: mail.attachments,
                                                                        messageId: mail.messageId,
                                                                        body: mail.body
                                                                    };
                                                                    setNowReading(index)
                                                                    localStorage.setItem("refresh", `${Date.now()}`);
                                                                    localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                                                    if (isXlOrLarger) {
                                                                        localStorage.removeItem('mailsent');
                                                                        localStorage.setItem('maildraft', JSON.stringify(mail));
                                                                        localStorage.removeItem('mailreceived');
                                                                        navigate('/desktop/translator/mailbox');
                                                                    } else {
                                                                        navigate('/mobile/translator/mailbox/composemail');
                                                                    }
                                                                }} >
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.other}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 30
                                                                            ? `${mail.subject.slice(0, 30)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 60
                                                                            ? `${mail.subject.slice(0, 60)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 70
                                                                            ? `${mail.subject.slice(0, 70)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 100
                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 140
                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                    </div> */}
                    <div className="mb-[100px] lg:mb-[130px] xl:mb-[20px]">
                        <div className="pl-[30px] pr-[30px] xl:pr-[5px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[20px] 2xl:pt-[25px]">
                            {
                                isLoading ?
                                    <div className="items-center justify-center flex pt-[30px]">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                    </div>
                                    :
                                    <div className="md:mx-[30px] lg:mx-[100px] xl:mx-[60px]">

                                        <div className="hidden xl:flex w-full gap-[15px] justify-evenly">
                                            <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600] ${folderSelected.compose_new ? 'bg-[#0E141F] bg-opacity-20 text-[#1E2533]' : 'bg-[#0E141F] text-[#ffffff]'}`}
                                                onClick={() => {
                                                    localStorage.setItem("folder", 4);
                                                    const mailRequest = {
                                                        type: 'new',
                                                        subject: 'nothing'
                                                    };
                                                    localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                                    setFolderSelected({ sent: false, inbox: false, draft: false, compose_new: true })
                                                    localStorage.setItem('composenewclicked', 'true');
                                                    navigate('/desktop/translator/mailbox')
                                                }}><MdAddCircleOutline size={19} />{t('t233')}</button>
                                            <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1 border-[#0E141F] font-[600] ${folderSelected.inbox ? 'bg-[#EFF4F7] text-[#1E2533]' : 'bg-transparent text-[#1E2533]'}`} onClick={() => { setNowReading(10000); localStorage.setItem("folder", 0); setFolderSelected({ sent: false, inbox: true, draft: false, compose_new: false }) }} ><MdMail size={19} />{t('t230')}</button>
                                            <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1 border-[#0E141F] font-[600] ${folderSelected.sent ? 'bg-[#EFF4F7] text-[#1E2533]' : 'bg-transparent text-[#1E2533]'}`} onClick={() => { setNowReading(10000); localStorage.setItem("folder", 1); setFolderSelected({ sent: true, inbox: false, draft: false, compose_new: false }) }}><MdSend size={19} />{t('t231')}</button>
                                            <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1 border-[#0E141F] font-[600] ${folderSelected.draft ? 'bg-[#EFF4F7] text-[#1E2533]' : 'bg-transparent text-[#1E2533]'}`} onClick={() => { setNowReading(10000); localStorage.setItem("folder", 2); setFolderSelected({ sent: false, inbox: false, draft: true, compose_new: false }) }}><MdFileCopy size={19} />{t('t232')}</button>

                                        </div>

                                        {
                                            !folderSelected.compose_new &&
                                            <div className="hidden xl:block bg-[#EFF4F7] py-[20px] px-[25px] rounded-xl mt-[15px]">
                                                <div className="hidden xl:grid xl:grid-cols-4  items-center justify-center gap-[10px]">
                                                    <input
                                                        type="search"
                                                        placeholder={t("t228")}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        value={searchInput}
                                                        className={`hidden xl:block col-span-3 p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px] ${lang === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[19px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (lang === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")}`}
                                                    />
                                                    <div className="hidden  h-[40px] xl:flex justify-center items-center text-[90px] md:text-[22px] xl:text-[16px] md:mr-[10px] w-full rounded-md  xl:px-[10px]  border border-1  border-gray-400 text-gray-700 bg-[#F1F6FB]">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                value={date ? dayjs(date) : null}
                                                                onChange={(date) => {
                                                                    if (date) {
                                                                        if (date) {
                                                                            const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                                            setDate(formattedDate)
                                                                        }
                                                                    }
                                                                }}
                                                                format="YYYY-MM-DD"
                                                                open={openDesktopCalendar} // this will open calendar programmatically
                                                                onClose={() => setOpenDesktopCalendar(false)}
                                                                components={{
                                                                    OpenPickerIcon: () => null,
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        InputProps: {
                                                                            style: {
                                                                                border: 'none',
                                                                                fontSize: '15px',
                                                                                color: '#000000',
                                                                                fontFamily: 'Urbanist',
                                                                            },
                                                                            endAdornment: null
                                                                        },
                                                                        placeholder: t('t229'),
                                                                        fullWidth: true,
                                                                        sx: {
                                                                            '& .MuiOutlinedInput-root': {
                                                                                border: 'none', // Remove outer border
                                                                                boxShadow: 'none', // Remove shadow
                                                                            },
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none', // Remove outlined border
                                                                            },
                                                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none', // Remove hover effect
                                                                            },
                                                                            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none', // Remove focus effect
                                                                            },
                                                                            '& input::placeholder': {
                                                                                color: '#6B7280',
                                                                                opacity: 1, // for consistent appearance in Firefox
                                                                                fontSize: {
                                                                                    xs: lang === 'en' ? '15px' : lang === "si" ? '19px' : '17px',
                                                                                    sm: lang === 'en' ? '16px' : lang === "si" ? '21px' : '18px',
                                                                                    md: lang === 'en' ? '19px' : lang === "si" ? '21px' : '19px',
                                                                                    lg: lang === 'en' ? '16px' : lang === "si" ? '17px' : '15px',
                                                                                    xl: lang === 'en' ? '16px' : lang === "si" ? '18px' : '18px'
                                                                                },
                                                                            },
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        </LocalizationProvider>

                                                        {
                                                            !showCloseIcon &&
                                                            <MdCalendarMonth
                                                                size="30px"
                                                                className="text-gray-500 ml-[10px] hover:cursor-pointer rounded-full focus:outline-none hover:ring-2 hover:ring-offset-2 hover:ring-gray-300 active:ring-2 active:ring-gray-400 active:ring-offset-2 transition duration-150 ease-in-out"
                                                                onClick={() => setOpenDesktopCalendar(true)}
                                                                tabIndex={0}
                                                                role="button"
                                                            />
                                                        }
                                                        {
                                                            showCloseIcon && <MdClose onClick={() => setDate(null)} size="30px" className="cursor-pointer 2xl:block text-gray-500 ml-[5px]" />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="bg-white px-[10px] py-[10px] mt-[20px]">
                                                    <div className="flex flex-col  justify-start">
                                                        <p className={`text-start font-bold ml-[10px] text-[#1E2533] ${lang === "en" ? "xl:text-[24px] 2xl:text-[28px]" : (lang === "si" ? "xl:text-[17px] 2xl:text-[18px]" : "xl:text-[18px] 2xl:text-[18px]")}`}>
                                                            {
                                                                folderSelected?.inbox ? t('t230') : (folderSelected.sent ? t('t231') : (folderSelected.draft ? t('t232') : t('t233')))
                                                            }
                                                        </p>
                                                        {
                                                            ((folderSelected?.inbox && filteredEmailsInbox.length === 0) || (folderSelected.sent && filteredEmailsSent.length === 0) || (folderSelected.draft && filteredEmailsDraft.length === 0)) &&
                                                            <div className={`text-center ml-[10px] mt-[20px]  text-[#6D7986] ${lang === "en" ? " xl:text-[15px] 2xl:text-[18px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[15px]")}`}>{t('t456')}</div>
                                                        }
                                                        {
                                                            (folderSelected?.inbox && filteredEmailsInbox.length !== 0 && numberOfUnread > 0) &&
                                                            <div className={`text-start ml-[10px] mt-[5px]  text-[#6D7986] ${lang === "en" ? " xl:text-[15px] 2xl:text-[18px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[15px]")}`}>{numberOfUnread} {t('t457')}</div>
                                                        }
                                                    </div>
                                                    {
                                                        folderSelected.inbox &&
                                                        <div className="mt-6">
                                                            {filteredEmailsInbox
                                                                .slice()
                                                                .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                                .map((mail, index) => (
                                                                    <div key={index} className={`cursor-pointer flex flex-col ${mail.isRead === false ? '' : ''}  ${(nowReading === index ? 'bg-[#FEFBE8]' : 'bg-transparent')} border-t border-t-[#C6CFD7] p-[10px]`}
                                                                        onClick={() => {
                                                                            setNowReading(index);
                                                                            handleInboxMailReadClick(mail, index);
                                                                        }}
                                                                    >

                                                                        <div className="flex justify-between">
                                                                            <div className="flex items-center justify-start gap-[5px]">
                                                                                {
                                                                                    mail.isRead === false &&
                                                                                    <MdCircle size={10} className={`fill-[#1CB789]`} />
                                                                                }
                                                                                <p className={`${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold`}>{mail.sender}</p>
                                                                            </div>
                                                                            <p className={`${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]`}>{mail.sentAt.slice(0, -3)}</p>
                                                                        </div>

                                                                        <div className={`hidden xl:block 2xl:hidden ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[13px] md:text-[17px] xl:text-[15px]`}>
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 100
                                                                                    ? `${mail.subject.slice(0, 100)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                        </div>
                                                                        <div className={`hidden 2xl:block ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[13px] md:text-[17px] xl:text-[15px]`}>
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 140
                                                                                    ? `${mail.subject.slice(0, 140)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                        </div>
                                                    }
                                                    {
                                                        folderSelected.sent &&
                                                        <div className="mt-6">
                                                            {filteredEmailsSent
                                                                .slice()
                                                                .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime()) // Descending order
                                                                .map((mail, index) => (
                                                                    <div key={index} className={`cursor-pointer flex flex-col  ${(nowReading === index ? 'bg-[#FEFBE8]' : 'bg-transparent')} border-t border-t-[#C6CFD7] p-[10px]`}
                                                                        onClick={() => {
                                                                            setNowReading(index)
                                                                            localStorage.setItem('mailsent', JSON.stringify(mail));
                                                                            localStorage.removeItem('maildraft');
                                                                            localStorage.removeItem('mailreceived');
                                                                            localStorage.setItem('composenewclicked', 'false');
                                                                            navigate('/desktop/translator/mailbox/read');
                                                                        }}>
                                                                        <div className="flex justify-between">
                                                                            <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.other}</p>
                                                                            <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                        </div>
                                                                        <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 100
                                                                                    ? `${mail.subject.slice(0, 100)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                        </div>
                                                                        <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 140
                                                                                    ? `${mail.subject.slice(0, 140)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                        </div>
                                                    }
                                                    {
                                                        folderSelected.draft &&
                                                        <div className="mt-6">
                                                            {filteredEmailsDraft
                                                                .slice()
                                                                .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime()) // Descending order
                                                                .map((mail, index) => (
                                                                    <div key={index} className={`cursor-pointer flex flex-col ${(localStorage.getItem('nowreading') === `${index}` ? 'bg-[#FEFBE8]' : 'bg-transparent')} border-t border-t-[#C6CFD7] p-[10px]`}
                                                                        onClick={() => {
                                                                            localStorage.setItem('nowreading', index);
                                                                            const mailRequest = {
                                                                                type: 'draft',
                                                                                threadId: mail.threadId,
                                                                                subject: mail.subject,
                                                                                to: mail.other,
                                                                                attachments: mail.attachments,
                                                                                messageId: mail.messageId,
                                                                                body: mail.body
                                                                            };
                                                                            setNowReading(index)
                                                                            localStorage.setItem("refresh", `${Date.now()}`);
                                                                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                                                            if (isXlOrLarger) {
                                                                                localStorage.removeItem('mailsent');
                                                                                localStorage.setItem('maildraft', JSON.stringify(mail));
                                                                                localStorage.removeItem('mailreceived');
                                                                                navigate('/desktop/translator/mailbox');
                                                                            } else {
                                                                                navigate('/mobile/translator/mailbox/composemail');
                                                                            }
                                                                        }} >
                                                                        <div className="flex justify-between">
                                                                            <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.other}</p>
                                                                            <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                        </div>

                                                                        <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 100
                                                                                    ? `${mail.subject.slice(0, 100)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                        </div>
                                                                        <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 140
                                                                                    ? `${mail.subject.slice(0, 140)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                </div>
                <div className=" ">
                    <>
                        <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                            <div className="flex items-center mt-[20px] lg:ml-[70px] xl:ml-[0px] justify-between">
                                <div className="flex items-center justify-between w-full md:mr-[30px] lg:mr-[130px] xl:mr-[10px]">
                                    <div className="flex items-center">
                                        <p className={`font-bold ml-[10px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[22px] 2xl:text-[24px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[18px] 2xl:text-[20px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[17px] 2xl:text-[20px]")}`}>{t('t234')}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <>
                                            <button className={`px-[20px] py-[8px] gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md  border border-1  border-[#0E141F] font-[600]`}
                                                onClick={handleReplyButton}>{t('t260')}</button>
                                        </>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center justify-center w-full">
                                <div className="flex items-center w-full md:w-[600px] justify-end">
                                    <div className="flex items-center mt-[5px]">
                                        {
                                            showLeftArrow &&
                                            <>
                                                <MdArrowLeft onClick={handleLeftArrow} size={40} className="md:hidden" />
                                                <MdArrowLeft onClick={handleLeftArrow} size={50} className="hidden md:block" />
                                            </>
                                        }

                                        {
                                            showRightArrow &&
                                            <>
                                                <MdArrowRight onClick={handleRightArrow} size={40} className="md:hidden" />
                                                <MdArrowRight onClick={handleRightArrow} size={50} className="hidden md:block" />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>

                            {
                                isLoading ?
                                    <div className="items-center justify-center flex pt-[30px]">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                    </div>
                                    :
                                    <>
                                        <div className="flex items-center justify-center">
                                            <div className="w-full md:w-[600px] items-center mt-[5px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                {isReceived &&
                                                    <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                                }
                                                {!isReceived &&
                                                    <p className={`text-gray-500 text-[15px]`}>{t('t220')}:</p>
                                                }
                                                {messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow]?.sender &&
                                                    isReceived && <input value={messagesArray[indexOfMessageShowingNow].sender} readOnly type="text" name="receptionist" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                                    />
                                                }
                                                {
                                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] &&
                                                    !isReceived && (
                                                        <input
                                                            value={messagesArray[indexOfMessageShowingNow].receiver || ""}
                                                            readOnly
                                                            type="text"
                                                            name="receptionist"
                                                            className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                                        />
                                                    )
                                                }
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-center">
                                            <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                                <input readOnly value={(content.subject.trim()) ? content.subject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.subject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-[20px] md:pl-[100px] lg:pl-[200px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                            {
                                                messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.attachments &&
                                                <>
                                                    {(messagesArray[indexOfMessageShowingNow].attachments).map((file, index) => (
                                                        <div key={index} className="flex items-center justify-between">
                                                            <div href={file.fileData} download={file.fileName}>
                                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                                    <MdFilePresent />
                                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            }
                                        </div>

                                        <div className="md:flex md:justify-center md:items-center">
                                            {
                                                messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.body &&
                                                <div className="justify-center items-center w-full md:w-[600px]">
                                                    <ReactQuill
                                                        modules={{ toolbar: false }}
                                                        value={messagesArray[indexOfMessageShowingNow].body}
                                                        readOnly
                                                        theme="snow"
                                                        placeholder={t('t225')}
                                                        className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                                </div>
                                            }
                                        </div>
                                    </>
                            }

                            {/* {
                                        content.sender_job === 'student' &&
                                        <div className="flex justify-center">
                                            <button onClick={() => {
                                                localStorage.setItem('forwardingMailTeacher', JSON.stringify(content));
                                                navigate('/ResearcherEmailComposeMobile');
                                            }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Forward</button>
                                        </div>
                                    } */}
                        </div >

                    </>
                </div>
            </div>
            <div className="xl:hidden grid grid-cols-5 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/message.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" /></div>
            </div>

            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default TranslatorMessageDashboardWithReadDesktop;
